import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { AnyIntegration, IIntegrationVATS } from '../../../../interfaces/restaurant';

const urlRegex = new RegExp(
  '^(https?:\\/\\/)?' +
  '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
  '((\\d{1,3}\\.){3}\\d{1,3}))' +
  '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
  '(\\?[;&a-z\\d%_.~[\\]+=\\-/,]*)?' +
  '(\\#[-a-z\\d_]*)?$', 'i'
);

type EditIntegrationVastForm = {
  proxy: FormControl<boolean>;
  proxyUnifiedMode: FormControl<boolean>;
  vastTagUrl: FormControl<string>;
};

@UntilDestroy()
@Component({
  selector: 'app-edit-integration-vast',
  templateUrl: './edit-integration-vast.component.html',
  styleUrls: ['./edit-integration-vast.component.scss']
})
export class EditIntegrationVastComponent implements OnInit {

  @Input() set data(value: AnyIntegration) {

    if (value && value.provider === 'VAST') {
      const vatsValue = value as IIntegrationVATS;

      this.editIntegrationForm.get('proxy')?.setValue(vatsValue.proxy ?? false, { emitEvent: false });
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (vatsValue.proxy) {
        proxyUnifiedModeControl?.enable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(vatsValue.proxyUnifiedMode ?? false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.disable({ emitEvent: false });
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      }

      this.editIntegrationForm.get('vastTagUrl')?.setValue(vatsValue.credentials.vastTagUrl ?? '', { emitEvent: false });
    }
  }

  public editIntegrationForm: FormGroup<EditIntegrationVastForm> = new FormGroup({
      proxy: new FormControl<boolean>(false, { nonNullable: true, validators: [Validators.required] }),
      proxyUnifiedMode: new FormControl(
        {value: false, disabled: true},
        { nonNullable: true, validators: [Validators.required] }
      ),
      vastTagUrl: new FormControl('', { nonNullable: true, validators: [Validators.pattern(urlRegex), Validators.required] })
    }
  );

  @Output() edited = new EventEmitter<Partial<AnyIntegration>>();
  @Output() remove = new EventEmitter<void>();

  constructor(
    public dialogRef: MatDialogRef<any>,
    public notifier: NotifierService,
  ) {}

  ngOnInit(): void {
    this.addListeners();
  }

  private addListeners(): void {
    this.editIntegrationForm.get('proxy')?.valueChanges.pipe(
      untilDestroyed(this)
    ).subscribe((proxyValue: boolean) => {
      const proxyUnifiedModeControl = this.editIntegrationForm.get('proxyUnifiedMode');

      if (!proxyValue) {
        proxyUnifiedModeControl?.disable({emitEvent: false});
        proxyUnifiedModeControl?.setValue(false, { emitEvent: false });
      } else {
        proxyUnifiedModeControl?.enable({emitEvent: false});
      }
    });
  }

  public edit(): void {
    const formValue = this.editIntegrationForm.getRawValue();

    this.edited.emit({
      proxy: formValue.proxy,
      proxyUnifiedMode: formValue.proxyUnifiedMode,
      credentials: {
        vastTagUrl: formValue.vastTagUrl
      }
    });
  }

  public removeIntegration(): void {
    this.remove.emit();
  }
}
